{
  "splash": {
    "title": "Développé avec le support de Fonds Climat Montréal & TP QUÉBEC"
  },
  "all-listings": {
    "disconnected": {
      "text": "Créez votre compte ou connectez-vous pour voir les ressources disponibles dans le réseau Mutuo."
    },
    "needLogin": {
      "secondLine": "Créez votre compte ou connectez-vous pour voir les ressources disponibles dans le réseau Mutuo."
    },
    "empty": {
      "offer": {
        "firstLine": "Débutez votre aventure ici !",
        "primaryButtonText": "Publier pour tous",
        "secondLine": "Participez au catalogue en offrant des équipements à prêter."
      },
      "invite": {
        "primaryButtonText": "Invitez les autres municipalités",
        "secondLine": "Invitez des municipalités ou publiez une offre dans votre quartier."
      }
    },
    "bonificationPrompt": {
      "title_one": "Un équipement à bonifier!",
      "title": "{{numListings}} équipements à bonifier!",
      "text_one": "Vous avez <strong>un équipement</strong> avec une photo générique ou aucune description. Les équipements avec une photo ont plus de chances d'être empruntés!",
      "text": "Vous avez <strong>{{numListings}} équipements</strong> avec une photo générique ou aucune description. Les équipements avec une photo ont plus de chances d'être empruntés!",
      "button_one": "Compléter la fiche de l'équipement"
    },
    "hasAcceptedLoan": "a prêté l'équipement",
    "hasAcceptedLoanAgo": "a prêté l'équipement il y a {{ago}}",
    "banner": {
      "xmas": {
        "text": "Les Fêtes arrivent ! Aidez les autres municipalités à trouver ces équipements souvent demandés."
      }
    },
    "noResults": {
      "firstLine": "Les membres n'ont pas encore publié d'équipements ici."
    },
    "numResults": {
      "offer_zero": "Équipements à prêter",
      "offer_one": "{{count}} équipement à prêter",
      "offer": "{{count}} équipements à prêter"
    },
    "postOfferPrompt": {
      "first": {
        "text": "Publiez 5 équipements et gagnez votre <strong>abonnement annuel</strong> !"
      },
      "third": {
        "text": "Les membres ont souvent plus d'équipements à prêter que ce qui est affiché. Demandez, on ne sait jamais.",
        "title": "Demandez aux autres municipalités"
      },
      "firstAfter": {
        "button": "Inviter les autres municipalités",
        "title": "Invitez les autres municipalités !"
      }
    },
    "partialSearchBar": {
      "empty": "Aucun équipement ne correspond à cette recherche."
    },
    "subtype": {
      "object": "Équipement"
    },
    "inviteOthersPrompt": {
      "ctaButton": "Invitez les autres municipalités"
    }
  },
  "common": {
    "appName": "Mutuo",
    "appDownloadPrompt": {
      "guest": "Vous aimez ce que vous voyez? Retrouvez Mutuo sur votre téléphone et recevez les nouvelles disponibilités près de chez vous",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application Mutuo"
    },
    "expiredLoans": {
      "title": "Avez-vous retourné l'équipement emprunté ?"
    },
    "searchPlaceholder": "Rechercher des annonces, des membres et des équipements..."
  },
  "contact-information": {
    "prompt": "Ajoutez le code postal de la municipalité afin de voir quels équipements sont disponibles à proximité.",
    "title": "Votre adresse",
    "prompt-public": "Ajoutez votre code postal afin de voir les annonces disponibles à proximité.",
    "title-public": "Votre code postal",
    "mapStatsPrompt": "Changez le rayon de recherche pour visualiser le nombre de membres et le nombre d'équipements qui sont disponibles à emprunter autour de chez vous."
  },
  "contact-us": {
    "firstParagraph": "Le service aux membres de Mutuo est accessible par courriel et messagerie. Nous vous répondrons le plus rapidement possible.",
    "faqLink": "https://www.iveo.ca/membres/mutuo-questions-nous-sommes-la-pour-y-repondre-foire-aux-questions-faq",
    "chatPrompt": {
      "bugReport": "Bonjour ! 😊\n\nMerci de nous expliquer ce qui ne va pas.",
      "suggestion": "Bonjour ! 😊\n\nOn est toujours ouverts aux suggestions. Merci de nous aider à améliorer notre service.\n\nMerci !"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Seuls les membres d'IVÉO peuvent utiliser cette application. Pour obtenir le code d'invitation, contactez <a>IVÉO</a>.",
    "activationCodeFieldHelpLink": "https://www.iveo.ca/membres/mutuo"
  },
  "guidelines": {
    "fifthParagraph": "Ne pas utiliser Mutuo pour vendre des équipements.",
    "secondParagraph": "<strong>Veiller à remettre les équipements empruntés</strong> dans l'état dans lequel ils ont été prêtés. Si un dommage survient, nous recommandons à l'emprunteur de réparer ou de remplacer l'équipement concerné.",
    "secondParagraphInsured": "<strong>Veiller à remettre les équipements empruntés</strong> dans l'état dans lequel ils ont été prêtés. Avec votre abonnement, si un dommage survient aux équipements que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu'à 300 $ par an</strong>. N'hésitez pas à nous contacter via la messagerie de l'app ou par courriel à info@partage.club.",
    "startingKit": "Je veux recevoir la <startingKitLink>Trousse de départ</startingKitLink> par la poste pour recruter d'autres municipalités (optionnel)"
  },
  "help": {
    "borrower": {
      "steps": {
        "catalog": {
          "title": "Parcourez le catalogue"
        },
        "meeting": {
          "text": "Proposez et confirmez des dates d'emprunt et de ramassage avec la Municipalité"
        }
      }
    },
    "lender": {
      "steps": {
        "publish": {
          "suggestedLink": "Choisir parmi les équipements suggérés"
        },
        "share": {
          "title": "Organiser le prêt",
          "text": "Organisez une rencontre avec la Municipalité pour qu’elle récupère l’équipement."
        },
        "return": {
          "title": "Récupérez votre équipement",
          "text": "Reprenez votre équipement à la fin du prêt et partagez votre expérience. Souvent, les équipements reviennent encore plus propres. C'est magique."
        }
      }
    }
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint Mutuo",
        "title": "Explorateur"
      }
    }
  },
  "introModal": {
    "title": "Cher {{name}},",
    "first": "Merci de rejoindre la communauté et faire un premier pas vers la réduction de votre consommation et la création de nouveaux liens !",
    "second": "<strong>Partager est une preuve de confiance</strong> : plus vous prêtez, plus les autres auront envie de vous prêter !",
    "third": "<strong>Sachez que moins de 0,1% de tous les partages</strong> engendrent un bris. Et ce n'est pas de mauvaise foi. C'est juste normal quand les équipements sont un peu plus utilisés.",
    "welcome": {
      "trial": {
        "CAD": "<strong>Empruntez sans limite pendant 3 semaines !\n</strong><padding/>Prêter vos équipements ?\nGratuit à vie.\n<padding/><smaller>À la fin de l'essai, abonnez-vous pour continuer à emprunter (2 options) :\n<padding/><strong>• 8 $/mois</strong> (résiliable en tout temps)\n<strong>• 60 $/an</strong> (économisez 36 $ !)\n<padding/><underline>Aucun paiement sans votre accord.</underline></smaller>",
        "EUR": "<strong>Empruntez sans limite pendant 3 semaines !\n</strong><padding/>Prêter vos équipements ?\nGratuit à vie.\n<padding/><smaller>À la fin de l'essai, abonnez-vous pour continuer à emprunter (2 options) :\n<padding/><strong>• 9 €/mois</strong> (résiliable en tout temps)\n<strong>• 72 €/an</strong> (économisez 36 € !)\n<padding/><underline>Aucun paiement sans votre accord.</underline></smaller>",
        "USD": "<strong>Empruntez sans limite pendant 3 semaines !\n</strong><padding/>Prêter vos équipements ?\nGratuit à vie.\n<padding/><smaller>À la fin de l'essai, abonnez-vous pour continuer à emprunter (2 options) :\n<padding/><strong>• 9 USD/mois</strong> (résiliable en tout temps)\n<strong>• 72 USD/an</strong> (économisez 36 USD !)\n<padding/><underline>Aucun paiement sans votre accord.</underline></smaller>"
      },
      "withWho": {
        "enterprise": "les autres municipalités",
        "municipal": "les autres municipalités",
        "municipal_closed": "les autres municipalités",
        "realestate": "les autres municipalités"
      }
    },
    "insurable": {
      "insurance": {
        "trial": "Avec votre abonnement, si un dommage survient aux équipements que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu'à 300 $ par an</strong>.",
        "regular": "Grâce à votre abonnement, si un dommage survient à vos équipements d'une valeur de 25 $ ou plus pendant un prêt, <strong>nous nous engageons à vous dédommager jusqu'à 300 $ par an</strong>."
      },
      "zeroOnePercent": "Rassurez-vous, moins de 0,1 % des partages entraînent un dommage. Il est tout à fait normal qu'un équipement présente des signes d'usure lorsqu'il est partagé et utilisé par plusieurs !"
    },
    "cleaner": "Et imaginez… <strong>les équipements reviennent souvent même plus propres qu'avant</strong>. C'est magique !",
    "offreDefricheur": "Il y a peu d'équipements dans votre quartier. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un équipement.",
    "borrow": "<strong>Vous pouvez maintenant emprunter</strong> parmi un large catalogue d'équipements disponibles à deux pas de chez vous.",
    "notInsurable": {
      "community": "<strong>C'est l'occasion parfaite pour faire connaissance avec les autres municipalités</strong>, et faire un pas vers un monde durable."
    }
  },
  "my-information": {
    "firstNameFieldLabel": "Nom de la municipalité",
    "credentialInformationTitle": "Compte et sécurité",
    "personalInformationTitle": "Informations du profil"
  },
  "my-personal-information": {
    "additionalNameFieldLabel": "Nom du département ou d'un référent",
    "additionalNameFieldPlaceholder": "ex. Département Environnement",
    "firstNameFieldLabel": "Nom de la municipalité",
    "firstNameFieldPlaceholder": "ex. Sainte-Jeanne-d'Argenteuil",
    "title": "Informations du profil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Votre abonnement à l’application de mutualisation MUTUO est offert par IVÉO."
      },
      "title": {
        "enterprise": "Abonnement Mutuo"
      }
    },
    "noEnd": "Cet abonnement est valide tant que vous êtes membre Mutuo.",
    "freeSubText": {
      "defricheur": "Il y a peu d'équipements dans votre quartier. <strong>Abonnement annuel gratuit aux 5 premier.ère.s</strong> qui publieront un équipement.",
      "trial": "Contribuez à faire grandir le catalogue du <strong>Partage Club</strong> ! Publiez 5 équipements et gagnez votre <strong>abonnement annuel</strong> !"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ex: Panneaux de signalisation temporaire",
      "descriptionFieldPlaceholder": {
        "offer": "Marque, dimensions, couleur, poids, état, année d'acquisition, conditions d'emprunt, spécificités de l'équipement ...",
        "request": "Marque, dimensions, couleur, poids, état, année d'acquisition, conditions d'emprunt, spécificités de l'équipement ..."
      },
      "nameFieldLabel": "Nom de l'équipement",
      "assistant": {
        "knowMore": {
          "text2": "Pour que l'assistant puisse vous aider au mieux, donnez un <strong>maximum de détails</strong> relatifs à l'équipement dans la description."
        }
      }
    },
    "bonificationPrompt": "Les équipements avec des photos réelles et une description complète inspirent davantage confiance et sont plus souvent empruntés.",
    "generalSection": {
      "oneOrMany": {
        "many": {
          "subtext": "Publiez plusieurs équipements en un clic, sans photo ni réflexion au préalable. C'est simple et rapide !"
        },
        "one": {
          "subtext": "Publiez votre équipement en le prenant en photo."
        }
      }
    },
    "multiImagePicker": {
      "emptyHint": "Ajoutez jusqu'à {{max}} photos. Les équipements avec des photos claires et bien éclairées sont empruntés plus souvent"
    },
    "chooseAutomaticMessage": {
      "defaultAutomaticMessage": {
        "greeting": "Bonjour {{firstName}}! Je cherche l'équipement suivant, et le système de recommandations pense que vous pourriez potentiellement m'aider :\n\n"
      }
    },
    "prompt": {
      "offer": {
        "one": "Prêter un équipement spécifique",
        "donation": "Donner un équipement",
        "many": "Choisir parmi des équipements suggérés"
      },
      "request": {
        "one": "Emprunter un équipement"
      },
      "publishAnObject": "Publier un équipement"
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenue dans le club",
        "body": "Découvrez Mutuo !"
      },
      "newly_insured": {
        "body": "Grâce à votre abonnement, si un dommage survient à vos équipements d'une valeur de 25 $ ou plus pendant un prêt, nous nous engageons à vous dédommager jusqu'à 300 $ par an."
      }
    },
    "welcome": "Bienvenue sur Mutuo !",
    "welcomeMessage": "Merci de nous faire confiance.",
    "rate": {
      "borrower": {
        "message": "Votre avis est important pour nous et pour les autres membres de Mutuo."
      },
      "lender": {
        "message": "Votre avis est important pour nous et pour les autres membres de Mutuo."
      }
    },
    "impactLevelExplorerMessage": "Commencez votre expérience au Partage Club. Publiez un équipement pour grandir votre impact et passer au niveau suivant.",
    "lateLoan": "Est-ce que l'équipement a été retourné ?",
    "newListingPostedSubscribed": "<strong>{{userName}}</strong> ({{distance}}) a publié une offre pour un équipement qui pourrait vous intéresser : {{itemName}}"
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Chère municipalité,",
      "text": {
        "lender": {
          "before": "Gérez la disponibilité de vos équipements : bloquez-les pour vos projets et mutualisez-les quand vous n'en avez pas besoin*.",
          "after": "Gérez la disponibilité de vos équipements : bloquez-les pour vos projets et mutualisez-les quand vous n'en avez pas besoin*."
        },
        "borrower": "N'oubliez pas de planifier vos journées de transport lors de votre emprunt*."
      },
      "subtext": {
        "lender": {
          "before": "*(Prévoyez le transport et la manutention si besoin)",
          "after": "*(Prévoyez le transport et la manutention si besoin)"
        },
        "borrower": "*(Prévoyez le transport et la manutention si besoin)"
      }
    },
    "conflictsInformationText": "Certains équipements sont <strong>déjà prêtés</strong> pour ces dates. Vous pouvez continuer la réservation, mais contactez l'emprunteur ensuite pour résoudre ce(s) conflit(s).",
    "informationText": "Réservez vos équipements pour les rendre indisponibles à l'emprunt pendant les jours sélectionnés."
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "Le besoin a été comblé sur Mutuo"
      }
    },
    "categorySection": {
      "primary": {
        "subtitle": "Sélectionnez la catégorie principale de l'équipement"
      }
    },
    "confirmReturnModal": {
      "text": {
        "borrower": "En confirmant le retour de cet équipement, vous signifiez que vous l'avez rendu à {{name}}.",
        "lender": "En confirmant le retour de cet équipement, vous signifiez que celui-ci vous a été rendu par {{name}}."
      }
    },
    "confirmDonationDoneModal": {
      "text": {
        "borrower": "En confirmant que le don a été ramassé, vous indiquez que {{name}} vous a bien donné cet équipement.",
        "lender": "En confirmant, vous reconnaissez avoir donné à {{name}} l'équipement en question."
      }
    },
    "createOfferModal": {
      "title": "Merci d'avoir prêté votre équipement"
    },
    "hasAcceptedLoan": "a prêté l'équipement",
    "hasAcceptedLoanAgo": "a prêté l'équipement il y a {{ago}}"
  },
  "personal-information": {
    "additionalNameFieldLabel": "Nom du département ou d'un référent",
    "additionalNameFieldPlaceholder": "ex. Département Environnement",
    "firstNameFieldLabel": "Nom de la municipalité",
    "firstNameFieldPlaceholder": "ex. Sainte-Jeanne-d'Argenteuil",
    "pictureFieldSubtitle": "Cette image sera affichée dans vos annonces et votre profil.",
    "pictureFieldTitle": "Ajouter une image du logo de la municipalité",
    "title": "Informations du profil",
    "firstNameFieldLabel-public": "Prénom",
    "firstNameFieldPlaceholder-public": "Prénom",
    "lastNameFieldLabel-public": "Nom",
    "lastNameFieldPlaceholder-public": "Nom",
    "phoneFieldLabel-public": "Numéro de téléphone",
    "pictureFieldSubtitle-public": "La photo de profil augmente la confiance entre membres",
    "pictureFieldTitle-public": "Ajouter une photo de profil",
    "title-public": "Vos informations personnelles"
  },
  "privacy": {
    "link1": "https://www.iveo.ca/membres/mutuo-conditions-generales",
    "link2": "https://www.iveo.ca/membres/mutuo-politique-de-confidentialite",
    "line3": "de Mutuo."
  },
  "quick-new-thanks": {
    "bodyText": "Vous venez de contribuer à enrichir le catalogue de <strong>Mutuo</strong> ! \n\nVous pouvez modifier vos offres à tout moment dans votre centre de partage.",
    "didYouKnowBody": "Les équipements avec une vraie photo ont 3x plus de chances d'être empruntés. Vous pouvez aller voir vos annonces pour les bonifier !"
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contacter IVÉO"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "En offrant vos équipements, vous encouragez même les municipalités les plus timides à demander.",
        "title": "Publier votre premier équipement"
      }
    },
    "publishOffers": {
      "step1": {
        "title": "Prendre soin des équipements"
      },
      "step2": {
        "text": "En offrant vos équipements, vous encouragez même <strong>les municipalités les plus timides</strong> à demander. Vous pouvez toujours prêter vos équipements, <strong>même sans abonnement</strong>.\n\nAppuyez sur l'icône pour continuer. (2/5)"
      },
      "step2AltCorp": {
        "text": "En offrant vos équipements, vous encouragez même <strong>les municipalités les plus timides</strong> à demander.\n\nAppuyez sur l'icône pour continuer. (2/5)"
      },
      "step3": {
        "title": "2 façons d'offrir vos équipements en partage",
        "text": "Publiez un équipement à la fois ou plusieurs équipements en même temps, en un clic. <strong>Sélectionnez l'offre multiple</strong> pour continuer. (3/5)"
      },
      "step5": {
        "title": "Publier un équipement à la fois",
        "text": "Vous pouvez à tout moment publier une offre individuelle en prenant une photo de votre équipement. (5/5)"
      },
      "stepFinal": {
        "text": "Vous maîtrisez à présent l'art de partager des équipements.\n\nVous avez augmenté votre impact en publiant votre première offre. Vous accédez désormais au niveau supérieur : Contributeur."
      }
    }
  },
  "presentPartageClub": {
    "headerTitle": "Bienvenue sur Mutuo",
    "title": "Bienvenue sur Mutuo",
    "community": {
      "headerText": "Mutuo, c'est l'application de <strong>partage d'équipements</strong> entre municipalités.",
      "footerText": "Profitez <strong>pleinement</strong> de la vie, sans vous limiter à ce que vous possédez."
    },
    "accessMore": {
      "headerText": "Sur Mutuo, vous accédez à une <strong>abondance d'équipements</strong>.",
      "footerText": "Équipement de sport, outils, jeux pour enfants, etc. : ici, vous trouvez <strong>vraiment tout</strong>."
    },
    "offerMore": {
      "headerText": "Sur Mutuo, votre <strong>générosité</strong> fait une vraie <strong>différence</strong>.",
      "footerText": "Faites <strong>profiter</strong> les autres de vos équipements trop peu utilisés. Ça fait du bien."
    }
  },
  "presentCommunity": {
    "headerTitle": "Bienvenue dans la communauté",
    "title": "Bienvenue dans la communauté",
    "congratulation": {
      "congratulation": "Félicitations !",
      "text1": "Vous êtes officiellement partageur.euse.",
      "text2": "Grâce à {{name}}, votre abonnement est offert.",
      "text3": "Profitez-en pour partager de façon illimitée avec la communauté."
    },
    "respect": {
      "headerText": "Une communauté <strong>attentionnée</strong> et <strong>respectueuse</strong> !",
      "footerText": "<strong>Moins de 1%</strong> des équipements empruntés sont endommagés. Et souvent, ils reviennent encore plus propres. C'est magique."
    },
    "transaction": {
      "headerText": "Sur Mutuo, vous pouvez <strong>partager</strong> (avec ou sans frais*) ou <strong>donner</strong>",
      "footerText": "Ici, on <strong>s'entraide</strong>. On <strong>prête</strong>.\nOn <strong>emprunte</strong>. On <strong>donne</strong>.",
      "footerSmallText": "*Le paiement des frais lors de l'emprunt est à la discrétion des membres et se fait hors de l'appli."
    },
    "responsibility": {
      "footerText": "Grâce à votre abonnement, si un équipement d'une valeur de 25 $ ou plus est endommagé pendant un prêt, on vous dédommage <strong>jusqu'à 300 $ par an.</strong>"
    }
  },
  "quickInterest": {
    "headerTitle": "Centres d'intérêt",
    "title": "Quels sont vos centres d'intérêt ?",
    "subtitle": "Personnalisez vos recommandations et soyez notifié des nouvelles offres.",
    "instruction": "Sélectionnez un ou plusieurs intérêts :",
    "nothingSelectedError": {
      "buttonText": "Retour",
      "text": "Vous devez sélectionner au minimum un centre d'intérêt pour continuer.",
      "title": "Sélectionnez 1+ centre(s) d'intérêt"
    },
    "button": {
      "confirm": "Confirmer",
      "skip": "Peut-être plus tard"
    }
  },
  "interests": {
    "explain": {
      "title": {
        "borrower": "Cher·ère\nmembre !",
        "lender": "Cher·ère\nmembre !"
      },
      "subtitle": {
        "borrower": "Dites-nous ce que vous aimez et ce que vous rêvez d'essayer pour que l'on vous propose des équipements faits pour vous.",
        "lender": "Montrez aux autres membres ce que votre municipalité a à offrir.\n\nBesoin d'inspiration ?\nParlez-nous un peu de votre municipalité et nous vous suggérerons des idées d'équipements à prêter.",
        "both": "Dites-nous ce que vous aimez et ce que vous rêvez d'essayer pour qu'on vous propose des équipements faits pour vous."
      }
    },
    "nothingSelectedError": {
      "text": "Vous devez sélectionner au minimum un équipement pour continuer.",
      "title": "Sélectionnez 1+ équipement(s)"
    },
    "chooseTag": {
      "title": {
        "lender": "Choisissez les catégories d'équipements que vous possédez"
      },
      "subtitle": {
        "lender": "Ça nous aidera à vous proposer des idées d'équipements à prêter."
      }
    },
    "chooseListing": {
      "subtitle": {
        "borrower": "On a repéré des équipements qui correspondent à vos intérêts ! Ajoutez-les dans vos favoris.",
        "lender": "Nous avons trouvé des équipements souvent demandés que vous pourriez prêter.",
        "both": "On a repéré des équipements qui correspondent à vos intérêts ! Ajoutez-les dans vos favoris."
      },
      "aggregateTitle": {
        "borrower": "Selon les catégories choisies, voici des équipements qui pourraient vous intéresser.",
        "lender": "Selon les catégories choisies, nous avons trouvé des équipements souvent demandés que vous pourriez prêter.",
        "both": "Selon les catégories choisies, voici des équipements qui pourraient vous intéresser."
      }
    },
    "noListingsFound": "Malheureusement, aucun équipement n'a été trouvé pour cette catégorie."
  },
  "all-channels": {
    "filters": {
      "listing": "Par équipement"
    }
  },
  "landing-page": {
    "stepsToComplete": {
      "addListings": "Ajoutez ({{count}}/5) équipements à prêter"
    },
    "multipleOfferCard": {
      "title": "Avez-vous ces équipements ?",
      "desktopSubtitle": "Nous avons trouvé <strong>des équipements souvent demandés</strong> que vous seriez susceptible de prêter. Les offres sont déjà créées par nos soins, vous n'avez plus qu'à publier!",
      "subtitle": "Vous pouvez rapidement publier des équipements liés au thème de la semaine pour aider les autres municipalités à les trouver !"
    },
    "requests": {
      "emptyState": {
        "subtitle": "Nous vous préviendrons si des municipalités ont besoin d'aide"
      }
    }
  },
  "api-errors": {
    "Can't delete listing that has accepted loan": {
      "": {
        "offer": "Vous ne pouvez pas supprimer une offre dont le prêt est présentement en cours ou en retard. Vous devez soit annuler ce prêt, ou confirmer le retour de cet équipement."
      }
    }
  },
  "billboard": {
    "title_2": "l'équipement qu'il vous faut!"
  },
  "closestListingsChoose": {
    "instructions": "Choisissez l'équipement que vous souhaitez emprunter, on s'occupe du reste."
  },
  "collection": {
    "subscriptionSuccess": "Vous êtes abonné. Vous recevrez une notification quand un membre publie une offre pour cet équipement.",
    "unsubscriptionSuccess": "Vous êtes désabonné. Vous ne recevrez plus de notification pour cet équipement."
  },
  "free-sub": {
    "headerTextTutorial": "Vous maîtrisez à présent l'art de partager des équipements.",
    "subHeaderTextTutorial": "Merci d'avoir publié un équipement. Nous sommes ravis de vous annoncer que votre abonnement annuel gratuit est maintenant activé !",
    "inviteButtonText": "Inviter les autres municipalités",
    "spreadTheLoveText": "Parlez-en aux autres municipalités pour qu'elles aussi puissent profiter de l'offre spéciale !"
  },
  "insured": {
    "listing": {
      "text": {
        "own": "Avec votre abonnement, vous profitez de la Responsabilité Partage Club en cas de dommage à vos équipements.",
        "other": "Avec son abonnement, {{name}} profite de la Responsabilité Partage Club en cas de dommage à ses équipements."
      }
    },
    "myPlan": {
      "text": "En vous abonnant, vous profitez de la Responsabilité Partage Club si un équipement que vous prêtez ou empruntez est endommagé."
    },
    "profile": {
      "title": "{{name}} profite de la Responsabilité Partage club en cas de dommage à ses équipements."
    },
    "details": {
      "text": {
        "own": "Avec votre abonnement, si un dommage survient aux équipements que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, nous nous engageons à vous dédommager jusqu'à <strong>300 $ par an</strong>.",
        "other": "Avec son abonnement, si un dommage survient aux équipements que {{name}} vous prête ou vous emprunte d'une valeur de 25 $ ou plus, nous nous engageons à le.la dédommager jusqu'à <strong>300 $ par an</strong>."
      }
    }
  },
  "invite": {
    "referralProgram": {
      "shareText": "Bonjour !\n\nJ'utilise Partage Club, une app pour partager des équipements du quotidien. C'est super pratique et je suis sûr·e que vous allez aimer. Rejoignez-moi :\n\n{{url}}"
    },
    "referralProgram202506": {
      "shareText": "Bonjour !\n\nJ'utilise Partage Club, une app pour partager des équipements du quotidien. C'est super pratique et je suis sûr·e que vous allez aimer. Rejoignez-moi :\n\n{{url}}"
    },
    "shareText": "Bonjour !\n\nJ'utilise Partage Club, une app pour partager des équipements du quotidien. C'est super pratique et je suis sûr·e que vous allez aimer. Rejoignez-moi :\n\n{{url}}",
    "title": "Invitez d'autres municipalités !"
  },
  "listings-filters": {
    "subtype": {
      "object": "Équipements"
    }
  },
  "loanDatesPicker": {
    "informationTextAsBorrower": "Proposez des dates au prêteur pour effectuer la réservation et suivre l'équipement jusqu'à son retour.",
    "informationTextAsLender": "Proposez des dates à l'emprunteur pour effectuer la réservation et suivre votre équipement jusqu'à son retour."
  },
  "loans": {
    "borrowing": {
      "empty": {
        "firstLine": "Aucun équipement emprunté"
      },
      "subtitle": "Les équipements que j'emprunte"
    },
    "lending": {
      "empty": {
        "firstLine": "Aucun équipement en prêt"
      },
      "subtitle": "Les équipements que je prête"
    },
    "past": {
      "savings": {
        "header": {
          "lending": "Économisé par les autres municipalités grâce à vous"
        }
      }
    }
  },
  "management": {
    "bonificationPrompt": {
      "text": "Certains de vos équipements sont disponibles, mais sans photo ou description."
    }
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "firstLine": "Le montant que les autres membres économisent en empruntant vos équipements s'affichera ici.",
        "secondLine": "Partagez vos équipements et voyez combien d'argent vous permettez aux membres d'économiser !"
      }
    },
    "howItWorks": {
      "body": "Nous utilisons un outil d'intelligence artificielle pour déterminer le prix de chaque équipement emprunté"
    },
    "subtext": {
      "borrowing": "en empruntant des équipements",
      "lending": "en prêtant mes équipements"
    }
  },
  "my-listings": {
    "hideAlert": {
      "message": "Ces équipements ne seront plus visibles par les autres, mais vous pourrez les restaurer plus tard ici."
    },
    "unhideAlert": {
      "message": "Ces équipements seront à nouveau visibles par les autres."
    },
    "deleteAlert": {
      "message": "Êtes-vous sûr de vouloir supprimer ces équipements ? Cette action est irréversible."
    }
  },
  "neighbour-profile": {
    "placeHelp": {
      "description": {
        "3": " des équipements entre eux mais aussi ",
        "4": " des équipements proposés sur place"
      },
      "features": {
        "borrow": {
          "title": "Empruntez des équipements sur place",
          "description": "Choisissez et empruntez des équipements parmi la sélection proposée par le lieu"
        },
        "dropOff": {
          "title": "Déposez et ramassez des équipements très facilement",
          "description": "Ce lieu de partage accepte de garder temporairement les équipements prêtés afin que les emprunteurs viennent les récupérer quand ils le souhaitent"
        }
      }
    }
  },
  "notification-warn": {
    "subtitle": "Soyez alerté dès qu'une personne vous écrit pour emprunter vos équipements ou répondre à votre besoin."
  },
  "notifications-setting": {
    "chatHelp": "Recevez une notification lorsqu'un membre vous envoie un message privé, par exemple, pour vous emprunter un équipement."
  },
  "one-channel": {
    "loanManagement": {
      "body": {
        "late": {
          "lender": "La période d'emprunt est dépassée. Vous pouvez contacter {{name}} afin d'organiser un moment pour qu'il.elle vous retourne l'équipement. Lorsque vous aurez récupéré l'équipement, utilisez le bouton ci-bas.",
          "borrower": "La période d'emprunt est dépassée. Vous pouvez contacter {{name}} afin d'organiser un moment pour retourner l'équipement dès que possible. Lorsque vous aurez rendu l'équipement, utilisez le bouton ci-bas."
        },
        "returned": {
          "lender": "{{name}} a indiqué avoir retourné l'équipement. Pouvez-vous confirmer cela ?"
        }
      },
      "title": {
        "returned": {
          "lender": "L'équipement a été retourné ?",
          "borrower": "Vous avez retourné cet équipement"
        }
      }
    },
    "loanMessage": {
      "contentAccepted": "La réservation de l'équipement a été confirmée.",
      "contentAsBorrower": "Le prêteur doit confirmer pour que l'équipement soit réservé.",
      "contentAsLender": "L'emprunteur doit confirmer pour que l'équipement soit réservé.",
      "contentPending": "La proposition de dates doit être acceptée afin que l'équipement soit réservé.",
      "contentRejected": "La réservation de l'équipement a été annulée."
    },
    "bonification": {
      "borrowerPrompt": {
        "title": "🌟 Faites briller cet équipement !",
        "text": "Cet équipement mériterait une vraie photo ou une meilleure description. Proposez une amélioration !"
      },
      "lenderNudge": {
        "title": {
          "lend": "Quelqu'un veut emprunter votre équipement 👋",
          "sell": "Quelqu'un veut acheter votre équipement 👋",
          "give": "Quelqu'un veut recevoir votre équipement 👋"
        },
        "text": "Pour que l'échange se passe encore mieux, ajoutez une vraie photo et une courte description. Ça inspire confiance et rend votre équipement plus attrayant!",
        "cta": "Compléter la fiche de l'équipement"
      },
      "lenderReview": {
        "text1": "<strong>{{name}}</strong> a proposé des améliorations pour votre équipement."
      },
      "lenderReviewed": {
        "text": {
          "accepted": "Yahoo! Vous venez de compléter la fiche de votre équipement.",
          "rejected": "Vous avez refusé les modifications suggérées pour cette annonce. Vous pouvez améliorer la fiche de votre équipement par vous-même en allant dans vos offres."
        }
      }
    },
    "bonificationScreen": {
      "lender": {
        "titleLabel": "Nom de l'équipement"
      }
    }
  },
  "recommendations": {
    "one-to-many-similar-listings": {
      "title": {
        "offer": "Offres similaires",
        "request": "Besoins similaires"
      }
    },
    "urgent-needs": {
      "title": "Aidez les autres municipalités !"
    }
  },
  "one-loan": {
    "cancelLoanModal": {
      "text": {
        "borrowing": "En confirmant l'annulation de l'emprunt, vous signifiez au prêteur que vous n'avez plus besoin de cet équipement."
      }
    },
    "contactSupportAboutIncidentPrompt": {
      "insured": "Bonjour {{name}} ! 😊\n\nPas de souci, les imprévus ça arrive.\n\nPour qu'on puisse vous aider, pourriez-vous nous expliquer ce qui s'est passé et, si possible, nous envoyer quelques photos de l'équipement endommagé ?\n\nRassurez-vous, si un dommage survient aux équipements que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu'à 300 $ par an</strong>.\n\nMerci !",
      "uninsured": "Bonjour {{name}} ! 😊\n\nPas de souci, les imprévus ça arrive.\n\nPour qu'on puisse vous aider, pourriez-vous nous expliquer ce qui s'est passé et, si possible, nous envoyer quelques photos de l'équipement endommagé ?\n\n<strong>On est là pour vous aider.</strong>\n\nMerci !"
    },
    "history": {
      "late_x_days": "Équipement en retard · {{numDays}} jours",
      "late_yesterday": "Équipement en retard · 1 jour"
    },
    "saleHistory": {
      "late_x_days": "Équipement en retard · {{numDays}} jours",
      "late_yesterday": "Équipement en retard · 1 jour"
    }
  },
  "payment": {
    "modal": {
      "firstParagraph": "Merci de votre confiance. Grâce à votre abonnement, vous pouvez maintenant emprunter et prêter des équipements aux autres municipalités sans limite."
    },
    "mobileRedirect": {
      "subtitle": "L'abonnement Partage Club est en ce moment disponible uniquement sur l'app mobile.\nUne fois abonné(e), vous pourrez continuer d'utiliser le site web pour emprunter et prêter des équipements."
    }
  },
  "paywall": {
    "thirdFeature": "Partage Club est responsable des dommages causés aux équipements"
  },
  "paywall2": {
    "details": {
      "trial": "Avec votre abonnement, si un dommage survient aux équipements que vous prêtez ou empruntez d'une valeur de 25 $ ou plus,  <strong>nous nous engageons à vous dédommager jusqu'à 300 $ par an</strong>.\n\nCode promo : <strong>PARTAGE25</strong>",
      "regular": "Avec votre abonnement, si un dommage survient aux équipements que vous prêtez ou empruntez d'une valeur de 25 $ ou plus, <strong>nous nous engageons à vous dédommager jusqu'à 300 $ par an</strong>."
    }
  },
  "quick-new-choose": {
    "headerText": "En publiant des équipements, vous augmentez la confiance des autres envers vous.",
    "nothingSelectedError": {
      "text": "Vous devez sélectionner au minimum un équipement pour continuer.",
      "title": "Sélectionnez 1+ équipement(s)"
    }
  },
  "quick-new-confirm": {
    "headerText": "En <strong>appuyant sur Publier</strong>, les équipements sélectionnés seront publiés <strong>sur votre profil</strong> et d'autres personnes <strong>pourront vous les emprunter</strong>"
  },
  "ambassador": {
    "advantages": {
      "advantage5": {
        "title": "Accès à des équipements fournis par Partage Club",
        "body": "Gardez des équipements en pension et bénéficiez de l'accès à ces équipements"
      }
    },
    "mission": {
      "mission4": "Partager des équipements",
      "concrete2": "Garder des équipements en pension chez vous"
    }
  },
  "streak": {
    "tips": {
      "publishRequest": {
        "description": "Vous avez besoin d'un équipement? Les membres autour de vous essaieront de vous aider."
      },
      "publishOffer": {
        "description": "Publiez un équipement spécifique ou choisissez parmi les équipements suggérés."
      },
      "helpNeighbours": {
        "title": "Essayez d'aider les autres municipalités"
      }
    },
    "contributions": {
      "add_bio": {
        "description": "Présentez-vous en quelques mots pour donner envie aux autres membres de vous prêter et de vous emprunter des équipements."
      },
      "publish_offer": {
        "description": "Publiez un équipement spécifique, ou choisissez parmi les équipements suggérés, les offres déjà faites par les autres municipalités!"
      },
      "publish_request": {
        "description": "Vous avez besoin d'un équipement? Publiez un besoin, les membres autour de vous essaieront d'y répondre."
      },
      "add_avatar": {
        "description": "Une photo de profil rassure les autres municipalités et vous rend reconnaissable dans le quartier."
      },
      "dismiss_request": {
        "title": "Essayez d'aider les autres municipalités"
      },
      "send_message": {
        "description": "Brisez la glace! Écrivez à une municipalité pour proposer votre aide ou en savoir plus sur une annonce."
      }
    },
    "objectiveDetails": "L'objectif du mois est déterminé en fonction du nombre de municipalités participantes autour de vous et de la maturité de votre quartier.",
    "seriesDetails": "Pour garder la flamme du partage active, les municipalités doivent atteindre l'objectif de partages indiqué pour le mois.",
    "neighbourhoodFirstShare": "Dans votre quartier, <strong>{{percent}}% des autres municipalités</strong> ont fait leur premier partage <strong>en moins d'une semaine</strong>."
  },
  "trialPromo": {
    "details": "Contribuez à faire grandir le catalogue du <strong>Partage Club</strong> ! Publiez 5 équipements et gagnez votre <strong>abonnement annuel</strong> ! 🥳"
  },
  "tutorialModal": {
    "publishOffers": {
      "text": "<strong>Comment offrir vos équipements en partage</strong>"
    }
  },
  "my-neighbourhood": {
    "radiusDescription": "Votre rayon vous permet de partager vos annonces dans un périmètre limité de votre quartier. Les municipalités situées hors de cette zone ne pourront pas voir vos annonces."
  },
  "profile-overview": {
    "inviteNeighboursButtonLabel": "Inviter des municipalités"
  }
}
